'use strict';

import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import Span from '../../tag/Span';
import Row from '../../tag/Row';
import OTButtonGroup from '../../tag/OTButtonGroup';
import OTButton from '../../tag/OTButton';
import {
  KAYTTAJA,
  PYYDETTY,
  COXA_POLKU
} from '../../../definitions/PolkuConstants';
import { doRedirect } from '../../../data/service/coxapolku/actions';
import WindowUtils from '../../../utils/WindowUtils';
import Alert from '../../Alert';

import enabledlogoSrc from '../../../images/coxa-logo.png';
import disabledLogoSrc from '../../../images/coxa-logo-gray.png';

const CoxaPolkuServiceCard = (props) => {
  const {
    coxaPolku,
    doRedirect,
    integrations
  } = props;
  const [buttons, setButtons] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [coxaPolkuObject, setCoxaPolkuObject] = useState(null);

  const handleOnClick = () => {
    doRedirect()
        .then(({payload}) => {
          if (payload !== null && payload !== '') {
            WindowUtils.openInNewTab(payload);
          }
        }).catch( err =>
            console.log(err)
        );
  };

  useEffect(() => {
    const coxaPolkuObj = _.find(integrations.data, {name: COXA_POLKU});

    setCoxaPolkuObject(coxaPolkuObj);

    switch (coxaPolkuObj.status) {
      case PYYDETTY:
      case KAYTTAJA: {
        setButtons(
            <OTButtonGroup
                collapseOnMobile
                expectedCount="1"
                type="big">
              <OTButton
                  key="redirect"
                  message={`care.plan.status.${coxaPolkuObj.status}.button`}
                  onClick={handleOnClick}/>
            </OTButtonGroup>
        );
      }
    }

    if(coxaPolkuObj.status !== KAYTTAJA) {
      setDisabled(true)
    }
  }, [integrations]);


  return coxaPolkuObject && <>
        <FormattedMessage id={`coxa.care.plan.general.title`}>
          {(txt) => <h2>{txt}</h2>}
        </FormattedMessage>
      {coxaPolku.error && <Alert message={`default.error.message`} />}
        <>
          <Row className="coxapolku-block ot-card__care-plan-card ot-card">
                <Span len="12">
                  <Span len="4">
                    <div className={`ot-card__care-plan-card`}>
                      <img src={ disabled ? disabledLogoSrc : enabledlogoSrc} alt={''} />
                      <FormattedMessage id={`coxa.care.plan.general.title`}>
                        { txt =>
                            <p className={`ot-card__image-title ${disabled && "ot-card__image-title--disabled"}`}>
                              {txt}
                            </p>
                        }
                      </FormattedMessage>
                    </div>
                  </Span>
                  <Span len="6">
                <FormattedMessage
                    id={`coxa.care.plan.status.${coxaPolkuObject.status}.desc`}>
                  {(txt) => (
                      <p className={`care-plan-status-desc care-plan-status-${coxaPolkuObject.status}-desc`}>
                        {txt}
                      </p>
                  )}
                </FormattedMessage>

                    {buttons}
                  </Span>
                </Span>
          </Row>
        </>
      </>;
};

const mapStateToProps = (state) => {
  return {
    coxaPolku: state.services.coxaPolku,
    integrations: state.services.integrations,
  };
};

export default connect(mapStateToProps, { doRedirect })(CoxaPolkuServiceCard);
